


















import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from "@flashpointbv/solar-service-container";

@Component({
  name: 'image-slider',
  components: ServiceContainer().getComponents()
})

export default class extends Vue {
  @Prop({default: []}) private bannerItems?: Array<object>;
  @Prop({default: 400}) private bannerHeight: Number;

  private slideOptions: object = {
    loop: this.bannerItems.length > 1,
    slidesPerView: 'auto',
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: `.image__slider-container .swiper-navigation.--next`,
      prevEl: `.image__slider-container .swiper-navigation.--prev`
    },
  };

  private getImageSourceUrl(slide: any): string {
    if (this.$mobileDetect.mobile() && slide.image_path_mobile) {
      return slide.image_path_mobile;
    }

    return slide.image_path_desktop;
  }
}
